module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.1c18ec0f.xml";